import { useQuery } from '@tanstack/react-query'
import { keys } from '@/api/hooks/shared/keys'
import { searchHierarchyPage } from '@/api/map/hierarchySearch'

export function useSearchHierarchyPage(
  filter: string[],
  opts: { page?: number; serchById?: boolean; enabled?: boolean } = {},
) {
  const page = opts.page ?? 1
  const serchById = opts.serchById ?? false
  const enabled = (opts.enabled ?? true) && filter.length > 0

  return useQuery({
    queryKey: keys.searchHierarchyPage({ filter, page, serchById }),
    enabled,
    queryFn: () => searchHierarchyPage({ filter, page, serchById }),
  })
}
